<template>
    <v-dialog v-model="loading" hide-overlay persistent width="100">
      <v-card color="transparent" flat style="overflow: hidden;">
        <v-container class="pa-0">
          <v-row justify="center" align="center">
            <v-col class="text-center">
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    data() {
      return {
        loading: false
      };
    },
    methods: {
      show() {
        this.loading = true;
      },
      hide() {
        this.loading = false;
      }
    }
  };
  </script>
  
  <style scoped>
  </style>
  